import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { HIDE_LOADER } from "../../store/actions/constants";
import DefaultLoader from "../DefaultLoader";
import {
  LoaderOverlayMain,
  LoaderOverlayMainPadding,
  LoaderOverlayMainInner,
  LoaderText,
  LoaderButton
} from "./style";
import { Button } from "../../generic-components";

const LoaderOverlay = ({ message, cancel, timer = 60000 }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timeoutId = setTimeout(function () {
      if (timer) dispatch({ type: HIDE_LOADER });
    }, timer);

    return () => clearTimeout(timeoutId);
  }, [dispatch, timer]);

  return (
    <LoaderOverlayMain>
      <LoaderOverlayMainPadding>
        <LoaderOverlayMainInner>
          <DefaultLoader width="75px" />
          <LoaderText>{message}</LoaderText>
          {cancel
            ? (
              <LoaderButton>
                <Button primary nomargin expand onClick={() => {
                  dispatch({ type: HIDE_LOADER });
                }}>Cancel</Button>
              </LoaderButton>
            )
            : null
          }
        </LoaderOverlayMainInner>
      </LoaderOverlayMainPadding>
    </LoaderOverlayMain>
  );
}

export default LoaderOverlay;
